import styled from '@emotion/styled'
import { Card, Collapse, Typography } from '@mui/material'
import { Box } from '@mui/system'
import PageContainer from 'components/PageContainer'
import { useEffect, useState } from 'react'
import { withGoogleSheets } from 'react-db-google-sheets'
import CollapseIcon from 'assets/icons-gray/collapse.svg'
import GoogleSheetsProvider from 'react-db-google-sheets'
import { theme } from 'theme'
import { useResponsive } from 'hooks/useResponsive'

const Tag = styled(Box)<{ isActive: boolean }>`
  height: 40px;
  box-sizing: border-box;
  backdrop-filter: blur(16px);
  border-radius: 50px;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  padding: 7px 20px 9px 20px;
  cursor: pointer;
  font-weight: ${({ isActive }) => (isActive ? 600 : 400)};
  background: ${({ isActive }) =>
    isActive ? 'rgba(252, 120, 80, 0.12)' : 'rgba(255, 253, 251, 0.56)'};
  border: ${({ isActive }) =>
    isActive ? `2px solid${theme.palette.primary.main}` : '2px solid #ffffff'};
  color: ${({ isActive }) =>
    isActive
      ? `${theme.palette.primary.main}`
      : `${theme.palette.text.secondary}`};
`

const CIcon = styled.img`
  position: absolute;
  top: 27px;
  right: 24px;
  transition: all 0.5s;
`

const CollapseBox = (d: IFAQs) => {
  const [checked, setChecked] = useState(false)
  const { isTablet } = useResponsive()
  return (
    <Collapse
      // TODO: handle collapse on mobile
      in={checked || isTablet}
      collapsedSize={70}
      sx={{ borderRadius: '16px', cursor: 'pointer' }}
      onClick={() => setChecked(!checked)}
    >
      <Card sx={{ border: 'none' }}>
        <CIcon
          src={CollapseIcon}
          alt="CollapseIcon"
          style={{
            transform: checked ? 'rotate(0deg)' : 'rotate(-180deg)',
          }}
        />
        <Typography variant="body1" fontWeight={600} mb="24px">
          {d.question}
        </Typography>
        <Typography variant="body1">{d.answer}</Typography>
      </Card>
    </Collapse>
  )
}

interface IFAQs {
  question: string
  answer: string
  tag: string
}

const FAQsContent = (props: any) => {
  const [tags, setTags] = useState<string[]>(['All'])
  const [data, setData] = useState<IFAQs[]>([])
  const [filter, setFilter] = useState<string>('All')

  useEffect(() => {
    const _data: IFAQs[] = props.db.FAQs
    _data.forEach((d) => {
      if (!tags.includes(d.tag)) setTags([...tags, d.tag])
    })
    setData(_data)
  }, [props.db.FAQs, tags])

  return (
    <>
      <Typography variant="h4">FAQs</Typography>
      <Box display="flex" gap="12px" flexWrap="wrap">
        {tags.map((t) => (
          <Tag isActive={t === filter} onClick={() => setFilter(t)} key={t}>
            {t}
          </Tag>
        ))}
      </Box>
      {data
        .filter((d) => d.tag === filter || filter === 'All')
        .map((d, i) => (
          <CollapseBox key={i} {...d} />
        ))}
    </>
  )
}

const Content = withGoogleSheets('FAQs')(FAQsContent)

const FAQs = () => {
  return (
    <PageContainer>
      <GoogleSheetsProvider>
        <Content />
      </GoogleSheetsProvider>
    </PageContainer>
  )
}

export default FAQs
